import { findIndex } from 'lodash';
import * as uuid from 'uuid';

import { API_URL as BASE_API_URL } from '@funnels/constants';
import { MOCK_DATA } from '@funnels/mockdata';
import { ServerApplicationCreate, ServerApplicationUpdate } from '@funnels/types';

import { axios } from '../_common/axios';

const SHOULD_USE_MOCK_API = localStorage.getItem('_lendi_funnels_debug_use_mock_api') === 'true';
const API_URL = `${BASE_API_URL}/v1`;
// const API_URL = `https://applications-api-latest.lendi-paas-stg.net/v1`;

function create(application: ServerApplicationCreate): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve({ data: { id: uuid.v4() } });
  }

  return axios.post(`${API_URL}/applications`, application).then((res) => res.data);
}

function fetchAll(customerId?: string): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve({ data: MOCK_DATA.applications });
  }

  const params = customerId ? `?customerId=${customerId}` : '';

  return axios.get(`${API_URL}/applications${params}`).then((res) => res.data);
}

function fetch(applicationId: string): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    const index = findIndex(MOCK_DATA.applications, { id: applicationId });

    return Promise.resolve({ data: [MOCK_DATA.applications[index !== -1 ? index : 0]] });
  }

  return axios.get(`${API_URL}/applications/${applicationId}`).then((res) => res.data);
}

function update(applicationId: string, application: ServerApplicationUpdate): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve();
  }

  return axios.put(`${API_URL}/applications/${applicationId}`, application).then((res) => res.data);
}

export default { create, fetchAll, fetch, update };
